import MiiaFwConfig from '@/configs/config'
import type { HealthCheckerResult } from '@/types/accessor/api/healthChecker/healthChecker'
import { useApiGw } from '@/modules/miiaFw/composables/useApiGw'
import { useNetworkStore } from '@/stores/networkStore'

export const getIsOnlineHealthCheckerApi = async (): Promise<HealthCheckerResult> => {
  const { invokeApiGwFunc } = useApiGw()
  return await new Promise((resolve, reject) => {
    const networkStore = useNetworkStore()
    invokeApiGwFunc(
      // API Gatewayのエンドポイント
      MiiaFwConfig.config.apiGwEndpointCommon,
      // Lambda関数をコールするためのWebAPIのサブディレクトリ
      '/healthChecker',
      // Lambda関数に渡す引数
      {
        function: 'get',
        param: {}
      },
      // Lambda関数実行前の前処理のコールバック
      () => {},
      // 成功時のコールバック
      (res: HealthCheckerResult) => {
        resolve(res)
      },
      // 例外受信時のコールバック(引数: エラーメッセージ)
      err => {
        reject(err)
      },
      // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
      () => {
        // ネットワークステータスをオフラインに更新する
        networkStore.setOfflineStatus()
        reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
      },
      // 処理完了後に実行するコールバック
      () => {},
      // ローディングアイコンを表示しない
      false,
      true
    )
  })
}
